import { EDealType, EEstimationTargets, IFilters } from '@cian/valuation-main-filters-widget';
import { stringify } from 'qs';

const getFiltersQsForFlats = (filters: IFilters, estimationId?: number | null, offer?: number | null) => ({
  address: filters.address,
  roomsCount: filters.roomsCount,
  totalArea: filters.area,
  valuationType: EDealType.Sale,
  estimationId,
  offer,
});

const getFiltersQsForAgentReport = (filters: IFilters) => ({
  address: filters.address,
  roomsCount: filters.roomsCount,
  totalArea: filters.area,
  valuationType: EDealType.Sale,
});

const getFiltersQsForNewbuildings = (filters: IFilters) => ({
  address: filters.address,
  jkRoomsCount: filters.jkRoomsCount,
  newbuildingId: filters.newbuildingId,
});

export interface IGetFiltersQsParams {
  filters: IFilters;
  estimationId?: number | null;
  offer?: number | null;
  isAgent?: boolean | null;
}

export const getFiltersQs = ({ filters, estimationId, offer, isAgent }: IGetFiltersQsParams) => {
  let qsObj = {};

  /**
   * Если пользователь агент и пытается оценить квартиру (не ЖК) - формируем qs для страницы "Отчет для риелтора"
   */
  if (isAgent && filters.estimationTarget === EEstimationTargets.flat) {
    return stringify(getFiltersQsForAgentReport(filters), { skipNulls: true });
  }

  switch (filters.estimationTarget) {
    case EEstimationTargets.flat:
      qsObj = getFiltersQsForFlats(filters, estimationId, offer);
      break;
    case EEstimationTargets.newbuilding:
      qsObj = getFiltersQsForNewbuildings(filters);
      break;
  }

  return stringify(qsObj, { skipNulls: true });
};
